import React from "react";
import RawDataPreview from "./Pages/RawDataPreview";
import AbundanceDataPreview from "./Pages/AbundanceDataPreview";
import WeeklyReportPreview from "./Pages/WeeklyReportPreview";
import SpeciesPieChart from "./Pages/SpeciesPieChart";
import AbundanceLineGraph from "./Pages/AbundanceLineGraph";
import SpeciesStackedBarChart from "./Pages/SpeciesStackedBarChart";
import LoadingCircularProgress from "../LoadingCircularProgress";

const ReportsLayout = ({
  clickedButton,
  rawData,
  onDownloadData,
  columnVisibilityModel,
  setColumnVisibilityModel,
  loading,
  timeZone,
  dataGridRef,
}) => {
  const renderReport = () => {
    switch (clickedButton) {
      case "Raw-Data":
        return (
          <RawDataPreview
            dataGridRef={dataGridRef}
            data={rawData}
            onDownloadData={() => onDownloadData()}
            columnVisibilityModel={columnVisibilityModel}
            setColumnVisibilityModel={setColumnVisibilityModel}
            loading={loading}
            timeZone={timeZone}
          />
        );
      case "Species-Summary-Among-Collections":
        return (
          <AbundanceDataPreview
            dataGridRef={dataGridRef}
            data={rawData}
            onDownloadData={() => onDownloadData()}
            loading={loading}
          />
        );
      case "Weekly-Species-report":
        return (
          <WeeklyReportPreview
            dataGridRef={dataGridRef}
            data={rawData}
            onDownloadData={() => onDownloadData()}
            loading={loading}
          />
        );
      case "Pie-chart":
        return <SpeciesPieChart loading={loading} data={rawData} />;
      case "LineGraph-chart":
        return (
          <>
            <AbundanceLineGraph
              data={rawData}
              onDownloadData={() => onDownloadData()}
            />
            {loading && <LoadingCircularProgress />}
          </>
        );
      case "Bar-chart":
        return (
          <>
            <SpeciesStackedBarChart
              data={rawData}
              onDownloadData={() => onDownloadData()}
            />
            {loading && <LoadingCircularProgress />}
          </>
        );
      default:
        return (
          <>
            <div>No report available yet</div>
            {loading && <LoadingCircularProgress />}
          </>
        );
    }
  };

  return <div style={{ height: "100%", width: "100%" }}>{renderReport()}</div>;
};

export default ReportsLayout;
